const newsData = [
  {
    title: "New Initiative to Promote Education",
    content: "A new government initiative aims to boost education in rural areas. The program will provide free textbooks and teacher training.",
    link: "https://example.com/news1",
    image_link: "https://example.com/image1.jpg"
  },
  {
    title: "Local Farmers Celebrate Record Harvest",
    content: "Farmers in the region are rejoicing as this year's harvest has broken all previous records. Experts attribute the success to favorable weather conditions.",
    link: "https://example.com/news2",
    image_link: "https://example.com/image2.jpg"
  },
  {
    title: "Advertisement: XYZ Electronics - New Product Launch",
    content: "Introducing the latest innovation in electronics! XYZ Electronics is proud to announce the launch of our cutting-edge product. Learn more at https://example.com/xyz-product.",
    link: "https://example.com/advert1",
    image_link: "https://example.com/advert1.jpg"
  },
  {
    title: "Government Allocates Funds for Healthcare",
    content: "In a significant move, the government has allocated substantial funds to improve healthcare infrastructure across the country. Hospitals and clinics will receive much-needed upgrades.",
    link: "https://example.com/news3",
    image_link: "https://example.com/image3.jpg"
  },
  {
    title: "City Traffic Congestion Reaches New High",
    content: "The city is grappling with worsening traffic congestion. Residents are urging authorities to take immediate action to address the issue.",
    link: "https://example.com/news4",
    image_link: "https://example.com/image4.jpg"
  },
  {
    title: "Advertisement: Fashion Trends - Exclusive Sale",
    content: "Discover the latest fashion trends and enjoy exclusive discounts at our store. Visit us today at https://example.com/fashion-sale.",
    link: "https://example.com/advert2",
    image_link: "https://example.com/advert2.jpg"
  },
  {
    title: "Tech Startup Receives Funding",
    content: "A promising tech startup has secured significant funding from venture capitalists. The company plans to expand its operations and launch new products.",
    link: "https://example.com/news5",
    image_link: "https://example.com/image5.jpg"
  },
  {
    title: "Environmental Conservation Efforts in Full Swing",
    content: "Environmental organizations and volunteers are working tirelessly to conserve local ecosystems. Tree planting drives and clean-up campaigns are making a difference.",
    link: "https://example.com/news6",
    image_link: "https://example.com/image6.jpg"
  },
  {
    title: "Advertisement: Travel Adventures - Explore the World",
    content: "Embark on unforgettable travel adventures! Book your dream vacation today at https://example.com/travel-adventures.",
    link: "https://example.com/advert3",
    image_link: "https://example.com/advert3.jpg"
  },
  {
    title: "Economic Growth Predicted for the Coming Year",
    content: "Economists are optimistic about the country's economic outlook for the next year. Projections indicate steady growth and job opportunities.",
    link: "https://example.com/news7",
    image_link: "https://example.com/image7.jpg"
  },
  {
    title: "Celebrity Chef Opens New Restaurant",
    content: "Renowned chef, John Doe, has launched his latest culinary venture. Food enthusiasts can now savor exquisite dishes at his new restaurant.",
    link: "https://example.com/news8",
    image_link: "https://example.com/image8.jpg"
  },
  {
    title: "Advertisement: Fitness Revolution - Get in Shape",
    content: "Join the fitness revolution! Transform your body and health with our expert trainers. Sign up today at https://example.com/fitness-revolution.",
    link: "https://example.com/advert4",
    image_link: "https://example.com/advert4.jpg"
  },
  {
    title: "Government Announces Tax Reform",
    content: "In a bid to simplify the tax system, the government has announced comprehensive tax reforms. Experts believe this will benefit both individuals and businesses.",
    link: "https://example.com/news9",
    image_link: "https://example.com/image9.jpg"
  },
  {
    title: "Historic Landmark Restoration Underway",
    content: "Efforts to restore a historic landmark are gaining momentum. The restoration project aims to preserve the cultural heritage of the region.",
    link: "https://example.com/news10",
    image_link: "https://example.com/image10.jpg"
  },
  {
    title: "Advertisement: Home Decor - Redesign Your Space",
    content: "Transform your home with our exquisite home decor items. Explore our collection at https://example.com/home-decor.",
    link: "https://example.com/advert5",
    image_link: "https://example.com/advert5.jpg"
  }
];
module.exports = newsData;